<template>
  <li role="radio" :class="[baseCss, disabled ? ['disabled', 'pointer-events-none'] : null, 'relative']">
    <label :class="['cursor-pointer', 'outline-none', 'block', 'w-full']">
      <table-layout :y-align="$parent.yAlign">
        <row>
          <cell x-align="center" :style="{width: `${$parent.iconSize}em`}" :class="['p-1']">
            <input
              @change="onChange($event)"
              tabindex="-1"
              type="radio"
              :checked="$parent.checked === value"
              :disabled="disabled"
              :name="name"
              :class="['hidden']"
              :value="value" /><icon
            :name="$parent.iconBlank"
            :color="iconColor"
            :size="$parent.iconSize"
            :icon-provider="$parent.iconProvider"
            :color-lightness="iconColorLightness"
            :class="[`${baseCss}-icon-blank`, 'inline-block', 'align-middle']" /><icon
            :name="$parent.iconChecked"
            :icon-provider="$parent.iconProvider"
            :size="$parent.iconSize"
            :color="iconColor"
            :color-lightness="iconColorLightness"
            :class="[`${baseCss}-icon-checked`, 'inline-block', 'align-middle']" /><span
            :class="['v-ripple', 'inline-block', 'align-middle', setBgColor('iconColor', 'iconColorLightness')]" />
          </cell>
          <cell x-align="left" :class="['pt-1', 'pr-1', 'pb-1']" v-if="label">
            <span v-html="label" :class="[`${baseCss}-label`, `text-${$parent.labelSize}`, 'inline-block', 'align-middle', $parent.noWrapLabel ? ['whitespace-nowrap'] : null, $parent.truncateLabel ? 'truncate' : [], internalLabelColor]" />
          </cell>
        </row>
      </table-layout>
    </label>
  </li>
</template>
<script>
import methods from '../../mixins/methods'
import props from '../../mixins/props'
import computed from '../../mixins/computed'

export default {
  name: 'Radio',
  mixins: [
    methods,
    props,
    computed
  ],
  data () {
    return {
      name: null,
      baseCss: this.componentBaseCss('radio')
    }
  },
  mounted () {
    this.onMounted()
  },
  props: {
    value: {
      required: true
    },
    label: {
      type: String
    },
    disabled: {
      type: Boolean
    },
    labelColor: {
      type: String,
      default: 'black'
    },
    iconColor: {
      type: String,
      default: 'black'
    }
  },
  methods: {
    onChange ($event) {
      let value = $event.target.value
      if (value === 'true') {
        value = true
      }
      if (value === 'false') {
        value = false
      }
      this.$parent.$emit('input', value)
    },
    onMounted () {
      this.getParentProps()
    },
    getParentProps () {
      const parent = this.$parent
      this.name = parent.name
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/bcq-ui/components/radio/radio.vue